/**
MUI palette color for the selected rating button
*/
export const getRatingColor = (value: number): string => {
  if (value <= 3) return 'error.main';
  if (value <= 6) return 'warning.main';
  return 'success.main';
};

/**
MUI palette color for the rating section background
*/
export const getRatingBg = (value: number): string => {
  if (value <= 3) return 'error.light';
  if (value <= 6) return 'warning.light';
  return 'success.light';
};

/**
Rating values 0-10 for NPS scale
*/
export const RATINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;
